import React, { useEffect, useState, useContext } from 'react'
import './pastmeetings.css'
import { DELETE, POST } from '../../../../Common/HttpMethods/HttpMethods';
import { Url } from '../../../../../constants/ApiUrlConstants';
import { FaCheckCircle } from "react-icons/fa";
import { IoIosShareAlt } from "react-icons/io";
// ---------------------------------------------------------------------Packages--------------------------------------------------------------------------------
import moment from 'moment';
import MaterialTable from 'material-table';
import { ThemeProvider, createTheme } from '@mui/material';


// ---------------------------------------------------------------------React Icons--------------------------------------------------------------------------------
import { BsEye } from "react-icons/bs";
import { SlPencil } from "react-icons/sl";
import { contextData } from '../../../../../context/ContextProvider';
import { useNavigate } from 'react-router-dom';
import SuccessModal from '../../../../Common/Popups/SuccessModal';
import FailModal from '../../../../Common/Popups/FailModal';
import { BsDownload } from 'react-icons/bs'
import { GeneratePDF, TooltipBox, firstLineTextFromHtml, FacilityTableRow, color, getAllToFromOptionalEmailArr, Cuurent_RBAC_roles, Cuurent_USERNAME, Cuurent_EMAIL, getEmailClassification } from '../../../../CommonCase/CommonFunctions';

export const handleSessionExpClose = (navigate,setActive) => {
  sessionStorage.clear();
  navigate('/login');
  setActive('tab1');
}

export const handleSearch = (inp,dataCopy,setData) => {
  setData(dataCopy?.filter((i) => {
    return i.meetingSubject?.toLowerCase().includes(inp?.toLowerCase())
  })
  )
}
export const handleEditPast = (id,navigate) => {
  navigate("/main/meetings/edit-past-meeting", { state: { meetingId: id } });
}

// handleDelete.js
export const handleDelete = async (
  setOpenDeleteModal,
  setLoading,
  DELETE,
  Url,
  idToDelete,
  token,
  setOpenSuccessModal,
  setSuccessMessage,
  setToggleForCount,
  setSessionExpiredModal,
  setFailMessage,
  setOpenFailModal
) => {
  try {
    setOpenDeleteModal(false);  // Close delete modal
    setLoading(true);  // Show loading state

    // Make the API call to delete the meeting
    const deleteMeetingResp = await DELETE(Url.deleteMeeting.replace("{mid}", `${idToDelete}`), token);

    if (deleteMeetingResp.SUCCESS) {
      setLoading(false);
      setOpenSuccessModal(true);
      setSuccessMessage("Meeting Deleted Successfully.");
      setToggleForCount(prev => !prev); // Toggle count or whatever necessary
    } else if (deleteMeetingResp?.STATUS === 401) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (deleteMeetingResp?.STATUS === 400) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (deleteMeetingResp?.STATUS === 403) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (deleteMeetingResp?.STATUS === 404) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (deleteMeetingResp?.STATUS === 500) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    } else {
      setLoading(false);
      setOpenFailModal(true);
      setFailMessage("Failed To Delete Meeting.");
    }
  } catch (error) {
    setLoading(false);
    setOpenFailModal(true);
    setFailMessage("Failed To Delete Meeting.");
  }
};



export const hasAccess = (props,usermail ) => {
  const { allFullNamesArr, allEmailIdArr } = getAllToFromOptionalEmailArr(props?.participantsList);
  if (allEmailIdArr.includes(usermail)) {
    return true;
  }
  return false;
};


export  const handleEditAccess = (props, to, from, optional,usermail,Email,navigate) => {
  if (hasAccess(props, usermail)) {
    handleEditPast(props.mid,navigate)
  } else if (from[0]?.participantEmail == Email) {
    handleEditPast(props.mid,navigate)
  }
};


const PastMeetings = ({ tableIcons, selectedToDate, selectedPeriod, searchInp, selectedFromDate, toggleForCount, setToggleForCount }) => {
  const theme = createTheme();
  const { setViewPastMeeting, setLoading, setActive } = useContext(contextData);
  const navigate = useNavigate();
  // ---------------------------------------------------------------------Data States--------------------------------------------------------------------------------
  const [data, setData] = useState([]);
  const [dataCopy, setDataCopy] = useState([]);

  // rbac roles
  let rrbac = Cuurent_RBAC_roles();
  const username = Cuurent_USERNAME();
  let Email = Cuurent_EMAIL();
  let token = sessionStorage.getItem('TOKEN');

  const storedRbacRoles = JSON.parse(rrbac);
  const userRole = sessionStorage.getItem("USER")

  const [rbac, setRbac] = useState({});

  useEffect(() => {
    if (userRole !== "USER") {
      const roleWithQMSDashboard = storedRbacRoles?.find(role => role.useCase === "QMS Past Meetings");
      if (roleWithQMSDashboard) {
        setRbac(roleWithQMSDashboard);
      }
    }
  }, []);



  // ---------------------------------------------------------------------------Popup Utility----------------------------------------------------------------------
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [openFailModal, setOpenFailModal] = useState(false);
  const [failMessage, setFailMessage] = useState("");
  const [sessionExpiredModal, setSessionExpiredModal] = useState(false)


  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const [idToDelete, setIdToDelete] = useState()

  const handleCloseFailModel = () => {
    setOpenFailModal(false);
  }
  // ---------------------------------------------------------------------------Popup End----------------------------------------------------------------------

  const titleStyle = {
    borderRight: '1px solid #b8b8b8'
  }

  const getDashboardData = async () => {

    let allMeetingsBody = {
      fromDate: moment(selectedFromDate).format('YYYY-MM-DD'),
      toDate: moment(selectedToDate).format('YYYY-MM-DD'),
      meetType: "Past"
    }

    try {
      setLoading(true);
      let pastMeetingsResp = await POST(Url.getAllTypeOfMeetingWithCount, token, allMeetingsBody)
      const pastMeetings = pastMeetingsResp?.DATA?.pastMeeting;

      if (pastMeetingsResp.SUCCESS) {
        let newData = pastMeetings.map((item, ind) => {
          return { ...item, index: ind + 1 }
        })

        setData(newData);
        setDataCopy(newData);

        setLoading(false);
      }
      else if (pastMeetingsResp?.STATUS == 401) {
        setLoading(false)
        setSessionExpiredModal(true)
        setFailMessage("Session expired")
      }else if (pastMeetingsResp?.STATUS == 404) {
        setLoading(false)
      }else if (pastMeetingsResp?.STATUS == 400) {
        setLoading(false)
      }else if (pastMeetingsResp?.STATUS == 403) {
        setLoading(false)
      }else if (pastMeetingsResp?.STATUS == 500) {
        setLoading(false)
      }
      else {
        setLoading(false);
        setOpenFailModal(true);
        setFailMessage("Failed to fetch meetings.");
      }

    } catch (error) {

      setLoading(false);
      setOpenFailModal(true);
      setFailMessage("Failed to fetch meetings.");
    }
  }

  useEffect(() => {
    handleSearch(searchInp,dataCopy,setData)
  }, [searchInp])

  useEffect(() => {
    getDashboardData()
  }, [selectedFromDate, selectedToDate])

  // -----------------------------------------------------------------------Handle Delete Functionallity---------------------------------------------------------------

  const usermail = Email;


  // -----------------------------------------------------------------------Handle Edit Functionallity---------------------------------------------------------------


  // const hasAccess = (props) => {
  //   const { allFullNamesArr, allEmailIdArr } = getAllToFromOptionalEmailArr(props?.participantsList);
  //   if (allEmailIdArr.includes(usermail)) {
  //     return true;
  //   }
  //   return false;
  // };


  // const handleEditAccess = (props, to, from, optional,usermail,Email,navigate) => {
  //   if (hasAccess(props, usermail)) {
  //     handleEditPast(props.mid,navigate)
  //   } else if (from[0]?.participantEmail == Email) {
  //     handleEditPast(props.mid,navigate)
  //   }
  // };


  const columns = [
    {
      title: <p style={{ borderRight: '1px solid #b8b8b8', paddingLeft: '5px' , whiteSpace:'nowrap'}} className='serialNoHeader'>SR NO.</p>,
      field: '',
      sorting: false,
      render: (rowData, index) => {

        return (
          <div style={titleStyle} className='facillity-table-row-data'>
            <span style={{ width: '50px', textAlign: "right", paddingRight: "8px" }}>{rowData?.index}</span>

          </div>
        )
      }
    },
    {
      title: <p style={{ paddingLeft: '5px', borderRight: "1px solid #b8b8b8"  , whiteSpace:'nowrap' }}>TITLE</p>,
      field: 'meetingSubject',
      sorting: false,
      render: (rowData) => {

        return (

          <div style={{ ...titleStyle, paddingLeft: '0px', position: 'relative' }} className='facillity-table-row-data past-title-row'>


            <span className="elipsisData" style={{ width: "266px", paddingLeft: '4px' }}>{rowData.meetingSubject}</span>
            {rowData.meetingSubject &&
              <div className='meetingSubject-tool-tip1'>
                {rowData.meetingSubject}
              </div>}
          </div>
        )
      }
    },
    {
      title: <p style={{ borderRight: '1px solid #b8b8b8', paddingLeft: '5px' , whiteSpace:'nowrap' }}>DATE & TIME</p>,
      field: 'parseStartDate',
      sorting: false,
      render: (rowData) => {

        return (
          <div style={titleStyle} className='facillity-table-row-data'>
            <span style={{ width: "200px", }}>   {rowData.parseStartDate},{rowData.startTime}-{rowData.endTime === "11:59 PM" ? "12:00 AM" : rowData.endTime}</span>
          </div>
        )
      }
    },
    {
      title: <p style={{ borderRight: '1px solid #b8b8b8', paddingLeft: '5px', width: '80px' , whiteSpace:'nowrap' }} >DURATION</p>,
      field: 'duration',
      sorting: false,
      render: (rowData) => {

        return (
          <div style={{ ...titleStyle, width: "80px" }} className='facillity-table-row-data'>
            {rowData.duration}
          </div>
        )
      }
    },


    {
      title: <p style={{ borderRight: '1px solid #b8b8b8', paddingLeft: '5px'  , whiteSpace:'nowrap' }} >VERSION</p>,
      field: 'duration',
      sorting: false,
      render: (rowData) => {

        return (
          <div style={{ ...titleStyle, width: "70px", }} className='facillity-table-row-data'>
            {!rowData?.momVersion ? "NA" : rowData?.momVersion}
          </div>
        )
      }
    },
    {
      title: <p style={{ borderRight: '1px solid #b8b8b8', paddingLeft: '5px' , whiteSpace:'nowrap' }} >RECORDED BY</p>,
      field: 'duration',
      sorting: false,
      render: (rowData) => {

        return (
          <div style={{ ...titleStyle, width: "120px", position: 'relative' }} className='facillity-table-row-data recorded-by-row'>

            <span className="elipsisData" style={{}}>{!rowData?.momRecordedBy?.fullName ? "NA" : rowData?.momRecordedBy?.fullName}</span>
            {rowData?.momRecordedBy?.fullName &&
              <div className='recorded-by-tool-tip1'>
                {rowData?.momRecordedBy?.fullName}
              </div>}
          </div>
        )
      }
    },
    {
      title: <p style={{ paddingRight: "5px", borderRight: "1px solid #b8b8b8", paddingLeft: '5px'  , whiteSpace:'nowrap'}} >STATUS</p>,
      field: 'momStatus',
      sorting: false,
      render: (rowData) => {

        return (
          <div style={{ ...titleStyle, position: 'relative' }} className="facillity-table-row-data momStatus-row-data" key={rowData.id}>
            <FacilityTableRow rowData={rowData} colorr={color} />
          </div>
        )
      }
    },

    {
      title: <p style={{ paddingLeft: '5px'  , whiteSpace:'nowrap'}} >ACTION</p>,
      field: '',
      sorting: false,
      render: (props) => {
        const { to, from, optional } = getEmailClassification(props?.emailDetail);
        return (
          <div className='action-btns' style={{ display: 'flex', gap: '3px', width: '60px', }} >
            <span className='Past-dot'></span>
            <span className='Past-dot'></span>
            <span className='Past-dot'></span>
            <TooltipBox
              meetingSummary={props?.meetingSummary}
              emailDetails={props?.emailDetail}
              usermail={usermail}
              mid={props?.mid}
              momVersion={props?.momVersion}
              setViewPastMeeting={setViewPastMeeting}
              handleEditAccess={()=>handleEditAccess(props, to, from, optional,usermail,Email,navigate)}
              GeneratePDF={GeneratePDF}
              props={props}
            />
          </div>
        )
      },
    }
  ];

  useEffect(() => {
    const text = document.getElementsByClassName("MuiTablePagination-selectLabel");
    [...text][0].innerHTML = "Show Entries";
    [...text][0].style.fontSize = "13px";
  }, [])

  const hrSummary = [
    {
      title: 'Human Computer Interaction (HCI) basic to advance. Based on 2023 new pattern',
      dateTime: '29 Sept 2023, 09:00 AM - 10:00 AM',
      duration: '61:00 Min',
      mom: 'Complete the In Process items for Requirement In Process items for...',
    },
    {
      title: 'Human Computer Interaction (HCI) basic to advance. Based on 2023 new pattern',
      dateTime: '29 Sept 2023, 09:00 AM - 10:00 AM',
      duration: '62:00 Min',
      mom: 'Complete the In Process items for Requirement In Process items for...',
    },
    {
      title: 'Human Computer Interaction (HCI) basic to advance. Based on 2023 new pattern',
      dateTime: '29 Sept 2023, 09:00 AM - 10:00 AM',
      duration: '63:00 Min',
      mom: 'Complete the In Process items for Requirement In Process items for...',
    },
    // Add more data items as needed
  ];


  const tableHeaderStyle = {
    backgroundColor: '#E2F7FF',
    color: "#00AFF1",
    fontWeight: "bold",
    height: 20
  };


  return (
    <div className='past-meeting-main-container'>
      <div className="Past-Meetings-table-container">
        <ThemeProvider theme={theme}>
          <MaterialTable
            data={data}
            localization={{ body: { emptyDataSourceMessage: <span className="no_data_found_table">No Records to show</span> } }}
            columns={columns}
            icons={tableIcons}
            options={{
              toolbar: false,
              search: false,
              draggable: false,
              pageSizeOptions: [5, 10, 15, 20],
              pageSize: 10,
              headerStyle: {
                position: 'sticky',
                top: -1,
                ...tableHeaderStyle
              },
              maxBodyHeight: '58vh',
              minBodyHeight: '58vh'
            }}
          />
        </ThemeProvider>
      </div>
      <SuccessModal
        openSuccessModal={openSuccessModal}
        setOpenSuccessModal={setOpenSuccessModal}
        successMessage={successMessage}
        setSuccessMessage={setSuccessMessage}
        recallFunctionOnOk={getDashboardData}
      />
      <FailModal
        openFailModal={openFailModal}
        setOpenFailModal={setOpenFailModal}
        failMessage={failMessage}
        setFailMessage={setFailMessage}
        recallFunctionOnOk={handleCloseFailModel}
        recallFunctiononClose={handleCloseFailModel}
      />

      <FailModal
        openFailModal={openDeleteModal}
        setOpenFailModal={setOpenDeleteModal}
        failMessage={failMessage}
        setFailMessage={setFailMessage}
        recallFunctionOnOk={() =>
          handleDelete(
            setOpenDeleteModal,
            setLoading,
            DELETE,
            Url,
            idToDelete,
            token,
            setOpenSuccessModal,
            setSuccessMessage,
            setToggleForCount,
            setSessionExpiredModal,
            setFailMessage,
            setOpenFailModal
          )
        }
        recallFunctiononClose={handleCloseFailModel}
      />

      {/* session expire modal  */}

      <FailModal
        openFailModal={sessionExpiredModal}
        setOpenFailModal={setSessionExpiredModal}
        failMessage={failMessage}
        setFailMessage={setFailMessage}
        recallFunctionOnOk={()=>handleSessionExpClose(navigate,setActive) }
        recallFunctiononClose={()=>handleSessionExpClose(navigate,setActive) }
      />
    </div>
  )
}

export default PastMeetings